import { Array } from 'stdlib/Array'

import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

import type { TBrowser } from '../definitions'

import {
  IE_BROWSERS, FF_BROWSERS, EDGE_BROWSERS,
  OPERA_BROWSERS, SAFARI_BROWSERS, CHROME_BROWSERS, ACCEPTED_BROWSERS
} from '../definitions'

/**
 * Browser típusának elkérése.
 * @param ua - UserAgent.
 */
export default function getBrowser (ua: string): TBrowser {
  const name = userAgentParser.getBrowser(ua)

  if (Array.includes(ACCEPTED_BROWSERS, name)) {
    if (Array.includes(CHROME_BROWSERS, name)) {
      return 'Chrome'
    }

    if (Array.includes(FF_BROWSERS, name)) {
      return 'Firefox'
    }

    if (Array.includes(EDGE_BROWSERS, name)) {
      return 'Edge'
    }

    if (Array.includes(IE_BROWSERS, name)) {
      return 'IE'
    }

    if (Array.includes(OPERA_BROWSERS, name)) {
      return 'Opera'
    }

    if (Array.includes(SAFARI_BROWSERS, name)) {
      return 'Safari'
    }
  }

  return undefined
}
